module.exports = __webpack_public_path__ + "static/img/zero.5af2a9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/zero.png
// module id = X87G
// module chunks = 48